import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS } from '../constants/apiEndpoints';
import type {
  BreederUpcomingPaymentListItem,
  BreederUpcomingPaymentSummaryResponse,
  CommissionReportSummaryResponse,
  MarketPlacePaymentTransactionOrderDetail,
} from '../types/interfaces/marketPlace.interfaces';
import type { ODataParams, StandardParams } from '../types/interfaces/apiParams.interfaces';
import qs from 'qs';

export const getMarketplacePaymentTransactionOData = (
  params?: ODataParams,
): Promise<AxiosResponse<MarketPlacePaymentTransactionOrderDetail[]>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.ODATA}`,
    undefined,
    {
    paramsSerializer: (p: Record<string, unknown>) => qs.stringify(p, { arrayFormat: 'repeat' }),
    params,
    },
  );
};

export const getCommissionReportSummary = (query?: object): Promise<AxiosResponse<CommissionReportSummaryResponse>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.MARKETPLACE_COMMISSION_REPORT_SUMMARY}`,
    query,
  );
};

export const downloadCommissionReport = (payload?: object, query?: object): Promise<AxiosResponse<any>> => {
  return appContextPost(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.MARKETPLACE_COMMISSION_REPORT_EXPORT}`,
    payload,
    query,
    {
      responseType: 'blob',
    },
  );
};

export const getMarketPlacePaymentReportTransactions = (params?: ODataParams) => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.ODATA}`,
    params,
  );
};

export const getMarketPlacePaymentReportSummary = (accountId: number, params?: ODataParams) => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}/${accountId}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.PAYMENT_REPORT_SUMMARY}`,
    params,
  );
};

export const getMarketPlaceSaleHistory = (accountId: number, params?: StandardParams) => {
  return appContextGet(`${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}/${accountId}/sale-history`, params);
};

export const getBreederUpcomingPaymentSummary = (params?: {
  accountId?: number;
}): Promise<AxiosResponse<BreederUpcomingPaymentSummaryResponse>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BREEDER_UPCOMING_PAYMENT_SUMMARY}`,
    params,
  );
};

export const getBreederUpcomingPayments = (
  params?: StandardParams & { accountId?: number },
): Promise<AxiosResponse<BreederUpcomingPaymentListItem[]>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BREEDER_UPCOMING_PAYMENTS}`,
    params,
  );
};

export const getMarketPlaceMyOrders = (
  params?: ODataParams & {
    accountId?: number;
  },
): Promise<AxiosResponse<MarketPlacePaymentTransactionOrderDetail[]>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.MY_ORDERS}`,
    params,
  );
};

export const getUnitsSold = (
  accountId: number,
): Promise<AxiosResponse<number>> => {
  return appContextGet(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}/${accountId}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.UNITS_SOLD}`,
  );
};
export const downloadBreederUpcomingPaymentsReport = (
  payload?: {},
  query?: { sellerAccountId?: number },
): Promise<AxiosResponse<any>> => {
  return appContextPost(
    `${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BASE}${MARKETPLACE_PAYMENT_TRANSACTION_ORDER_DETAIL_ENDPOINTS.BREEDER_UPCOMING_PAYMENTS_EXPORT}`,
    payload,
    query,
    { responseType: 'blob' },
  );
};
